import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiAddressesGet } from '@/entities/addresses/modules/api/addresses';

export const useAddresses = (enabled = true) =>
  useFetch({
    api: apiAddressesGet,
    keywords: queryKeys.addresses.all,
    enabled,
    staleTime: 60_000,
  });
